import { Link } from "react-router-dom";
import { INDUSTRIES } from "../../nav/navigation";

export function IndustriesMenu({ onNavigate }: { onNavigate: () => void }) {
  return (
    <div className="mm">
      <div className="mm__grid mm__grid--3">
        {INDUSTRIES.map((item) => (
          <Link
            key={item.href}
            to={item.href}
            className="mm__card"
            onClick={onNavigate}
          >
            <b>{item.name}</b>
            <span className="mm__blurb">{item.blurb}</span>
          </Link>
        ))}
      </div>
    </div>
  );
}
